import "../../index17.css";
import { jsx as r } from "react/jsx-runtime";
import { Children as d } from "react";
import { ChevronRightLineIcon as _ } from "@ifrc-go/icons";
import { _ as t } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
const h = "_breadcrumbs_c7c54_1", f = "_item_c7c54_6", N = "_separator_c7c54_18", a = {
  breadcrumbs: h,
  item: f,
  separator: N
};
function A(m) {
  const {
    className: c,
    children: o,
    separator: i = /* @__PURE__ */ r(_, {}),
    itemClassName: n
  } = m, p = d.toArray(o).reduce(
    (e, l, s, b) => {
      const u = /* @__PURE__ */ r(
        "div",
        {
          className: t(a.item, n),
          children: l
        },
        `breadcrumb-${s}`
      );
      return e.push(u), s !== b.length - 1 && e.push(
        /* @__PURE__ */ r(
          "span",
          {
            className: a.separator,
            children: i
          },
          `separator-${s}`
        )
      ), e;
    },
    []
  );
  return /* @__PURE__ */ r(
    "nav",
    {
      className: t(a.breadcrumbs, c),
      "aria-label": "breadcrumb",
      children: p
    }
  );
}
export {
  A as default
};
